import React, { lazy } from 'react'

const ApiPage = lazy(() => import('./ApiPage'))

export { ApiPage }
